"use client";

import { useEffect } from "react";
import type { SnsProvider } from "@/components/auth/SnsAuthButtons";

/**
 * OAuth 취소·뒤로가기(bfcache) 후 SNS 버튼 로딩이 남는 문제 방지
 */
export function useSnsOAuthLoadingRecovery(
  setSnsLoading: (value: SnsProvider) => void
) {
  useEffect(() => {
    const reset = () => setSnsLoading(null);

    const onPageShow = (event: PageTransitionEvent) => {
      if (event.persisted) {
        reset();
      }
    };

    const onVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        reset();
      }
    };

    window.addEventListener("pageshow", onPageShow);
    document.addEventListener("visibilitychange", onVisibilityChange);

    return () => {
      window.removeEventListener("pageshow", onPageShow);
      document.removeEventListener("visibilitychange", onVisibilityChange);
    };
  }, [setSnsLoading]);
}

export function scheduleSnsLoadingFallback(
  clear: () => void,
  ms = 2500
): () => void {
  const timer = window.setTimeout(clear, ms);
  return () => window.clearTimeout(timer);
}
